import { CreditCard } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PAYMENT_STEPS } from "./newThesisConstants";

export function PaymentTimingCard() {
  return (
    <Card className="border-amber-200 bg-amber-50/40">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-base">
          <CreditCard className="h-4 w-4 text-amber-700" />
          When do I pay?
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        <ol className="space-y-3 text-sm text-slate-700">
          {PAYMENT_STEPS.map((step) => (
            <li key={step.label} className="flex gap-3">
              <span className="mt-0.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-amber-500" />
              <div>
                <p className="font-medium text-slate-900">{step.label}</p>
                <p className="mt-0.5 text-xs leading-relaxed text-slate-600">{step.description}</p>
              </div>
            </li>
          ))}
        </ol>
      </CardContent>
    </Card>
  );
}
